import api from './api';

class DocumentService {
  async uploadDocument(file, metadata = {}) {
    const formData = new FormData();
    formData.append('file', file);
    
    if (metadata.project_id) formData.append('project_id', metadata.project_id);
    if (metadata.campaign_id) formData.append('campaign_id', metadata.campaign_id);
    if (metadata.title) formData.append('title', metadata.title);
    if (metadata.description) formData.append('description', metadata.description);
    if (metadata.category) formData.append('category', metadata.category);
    if (metadata.tags) formData.append('tags', metadata.tags.join(','));
    if (metadata.source) formData.append('source', metadata.source);

    const response = await api.post('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async listDocuments(filters = {}) {
    const params = new URLSearchParams();
    if (filters.project_id) params.append('project_id', filters.project_id);
    if (filters.campaign_id) params.append('campaign_id', filters.campaign_id);
    if (filters.document_type) params.append('document_type', filters.document_type);
    if (filters.source) params.append('source', filters.source);
    if (filters.category) params.append('category', filters.category);
    if (filters.tags) params.append('tags', filters.tags);
    if (filters.search) params.append('search', filters.search);
    if (filters.include_archived) params.append('include_archived', 'true');
    if (filters.page) params.append('page', filters.page);
    if (filters.per_page) params.append('per_page', filters.per_page);

    const response = await api.get(`/documents?${params.toString()}`);
    return response.data;
  }

  async getDocument(documentId) {
    const response = await api.get(`/documents/${documentId}`);
    return response.data;
  }

  async downloadDocument(documentId, fileName) {
    const response = await api.get(`/documents/${documentId}/download`, {
      responseType: 'blob',
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }

  async updateDocument(documentId, updates) {
    const response = await api.put(`/documents/${documentId}`, updates);
    return response.data;
  }

  async deleteDocument(documentId) {
    const response = await api.delete(`/documents/${documentId}`);
    return response.data;
  }

  async createMarkdownDocument(data) {
    const response = await api.post('/documents/create-markdown', data);
    return response.data;
  }

  async getDocumentVersions(documentId) {
    const response = await api.get(`/documents/${documentId}/versions`);
    return response.data;
  }
}

export default new DocumentService();
